import { EPaymentPeriod, EPriceType } from '../../../../repositories/monolith-python/entities/offer/BargainTermsSchema';
import { IOfferBuilding } from './building';
import { IOfferFlags } from './flags';
import { IOfferGeo } from './geo';
import { IOfferHomeowner } from './homeowner';
import { TOfferVideos } from './videos';
import { IMultiposting } from '../../../types/multiPosting/types';
import { IOfferLand } from './land';
import { TOfferCategory, TOfferDealType } from '../../../../types/reducers/offer';
import { EBusinessType } from '../../../../types/businessType';

export interface IOfferState {
  status: EOfferStatus;
  dealType: TOfferDealType;
  offerType?: string;
  category: TOfferCategory;
  categoryName?: string;
  bargainTerms: IOfferBargainTerms;
  isByHomeowner: boolean;
  isByCommercialOwner?: boolean;
  areaParts?: IAreaPart[] | null;
  layoutPhoto: ILayoutPhoto | null;
  photos: Array<string>;
  selfEmployedData?: IOfferSelfEmployedData;
  id: number | null;
  geo?: IOfferGeo;
  coworkingOfferType?: string;
  workplaceCount?: number;
  coworking?: ICoworking;
  allRoomsArea?: string;
  businessShoppingCenter?: IBusinessCenter;
  calltrackingPhone?: string;
  phones?: Array<IPhoneNumber | null>;
  terms?: Array<IOfferPublishTerms>;
  videos: TOfferVideos;
  isFromXml: boolean;
  isArchived: boolean;
  building?: IOfferBuilding | null;
  isRentByParts: boolean | null;
  rentByPartsDescription: string | null;
  objectGuid: string;
  calltrackingPhoneIndex: number | null;
  homeOwner: IOfferHomeowner | null;
  publishTerms: IOfferPublishTerms;
  flags?: IOfferFlags;
  isEnabledCallTracking?: boolean | null;
  multiposting: IMultiposting;
  communication?: ICommunication;
  readyBusinessType?: EBusinessType;
  isNeedExactAddress?: boolean;
  dealRentData?: IDealRentData | null;
  /** Кадастровый номер здания */
  buildingCadastralNumber?: string;
  /** Кадастровый номер участка */
  cadastralNumber?: string;
  isDacha?: boolean | null;
  /** Общая площадь, м2 **/
  totalArea?: number | null;
  land?: IOfferLand | null;
  specialty?: TSpecilty;
  userId?: number | null;
}

export interface IDealRentData {
  applyDealRentVersion: string | null;
  applyDealRentSource: string | null;
}

export interface ILayoutPhoto {
  id: number;
}

export interface IAreaPart {
  price?: number;
  area?: number;
  id?: string | number;
}

export interface ICoworkingWorkType {
  timeFrom?: string;
  timeTo?: string;
}

export type TCoworkingAmenity = string;

export type TCoworkingWorkplace = {
  cardUrl?: string;
  addformUrl?: string;
};

export interface ICoworking {
  name?: string;
  accessType?: 'weekdays' | 'daily';
  isRoundTheClock?: boolean;
  workTime?: ICoworkingWorkType;
  amenities?: TCoworkingAmenity[];
  flexibleWorkplace: TCoworkingWorkplace | null;
  fixedWorkplace: TCoworkingWorkplace | null;
}

interface IUtilitiesTerms {
  includedInPrice?: boolean;
  flowMetersNotIncludedInPrice?: boolean | null;
}

export enum ECurrency {
  /** € **/
  Eur = 'eur',
  /** ₽ **/
  Rur = 'rur',
  /** $ **/
  Usd = 'usd',
}

interface IOfferBargainTerms {
  /** Цена **/
  price: number;
  priceForWorkplace?: number;
  utilitiesTerms?: IUtilitiesTerms;
  clientFee: number | null;
  agentFee: number | null;
  deposit: number | null;
  agentBonus: IOfferAgentBonus | null;
  leaseTermType: string;
  /** Валюта **/
  currency: ECurrency;
  /** Тип цены **/
  priceType?: EPriceType | null;
  /** Период оплаты **/
  paymentPeriod?: EPaymentPeriod | null;
}

interface IOfferSelfEmployedData {
  isEnabled: boolean;
  inn: string | null;
}

export interface IBusinessCenter {
  /** id бизнес центра */
  id: number;
}

export interface IPhoneNumber {
  countryCode: string;
  number: string;
}

interface IOfferPublishTerms {
  autoprolong: boolean;
  terms: Array<IOfferPublishTerm>;
}

interface IOfferPublishTerm {
  days: number;
  dynamicPrice?: number;
  recommendedServicePackageId?: string;
  services: Array<string>;
  // TODO: дополнить описание
  tariffIdentificator: object;
  type: string;
}

interface ICommunication {
  preferredCommunicationType?: EPreferredCommunicationType;
}

export interface IOfferAgentBonus {
  paymentType: EPaymentType;
  value: number | null;
}

export enum EOfferStatus {
  draft = 'draft',
  published = 'published',
}

export enum EPaymentType {
  /** Фиксированный **/
  Fixed = 'fixed',
  /** Процент от сделки **/
  Percent = 'percent',
}

export enum EPreferredCommunicationType {
  Phone = 'phone',
  Forms = 'forms',
}

export type TSpeciality = {
  id: number;
  rusName: string;
  engName: string;
};

export type TSpecilty = {
  types?: string[];
  additionalTypes?: string[];
  specialties: TSpeciality[];
};
